import React, { useState, useEffect } from 'react';
import { View, StyleSheet, SafeAreaView, Platform, useWindowDimensions } from 'react-native';
import CustomSection from '../Section/CustomSection';
import CustomButton from '../../CustomButton/'
import CustomLabel from '../../CustomLabel/CustomLabel';
import { Checkbox } from 'react-native-paper';
import CustomInput from '../../CustomInput/CustomInput';
import { Card } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import { generateUniqueID } from '../CreateSurvey/CreateSurveyFunctions';
import { postSurvey, postResponses } from '../../../services/SurveyService';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import PopUp from '../PopUp/PopUp'
import KeyboardAwareContainer from '../../Platform/KeyboardAwareContainer';

const CustomSurvey = ({ survey, setSurvey, sectionQuestionList, setSectionQuestionList, questionOptionResponseList,
    setQuestionOptionResponseList, chartOptions, userSurveySectionList, noOfUsers, chartData, isEdit = 0, isResponse = 0, isResult = 0, isAnalytics = 0,
    setShowResponseScreen, setShowMySurveys, setShowSurveysAdmin, setShowCreateScreen, setShowEditScreen, isCreate = 0 }) => {

    const { user, clientApi } = useAuthContext();
    const { width, height } = useWindowDimensions()
    const token = user.token;
    const { colors } = useTheme();
    const styles = makeStyles(colors, width, height);
    const { t } = useTranslation();
    const [isResultNew, setisResult] = useState(isResult);
    const [errorCheck, setErrorCheck] = useState(false);

    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    
    //#region Survey Listeners - Must break down in smaller regions
    const handleQuestionTypeChange = (val, index, sectionIndex) => {
        console.log(val)
        const list = [...sectionQuestionList[sectionIndex].section_questions[index].question_options];
        const item = list.splice(0, 1);
        const qId = sectionQuestionList[sectionIndex].section_questions[index].id
        const Ratinglist = [
            {
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 0
            },
            {
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 1
            },
            {
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 2
            },
            {
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 3
            },
            {
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 4
            },
            {
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 5
            },
        ]
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                       section_questions: sQItr.section_questions.map((section_questions) =>
                            section_questions.question_order === index && val === "Rating Options"
                                ? { ...section_questions, input_type_name: val, question_options: Ratinglist }
                                : section_questions.question_order === index
                                    ? { ...section_questions, input_type_name: val, question_options: item }
                                    : { ...section_questions }
                        ),
                    }
                    : { ...sQItr }
            )
        );
    };

    // ! ---------------------------------
    // ! SECTION QUESTIONS
    // * Add questions in the coresponding section 
    const handleQuestionAdd = (index, sectionIndex) => {
        console.log(sectionQuestionList)
        console.log(index)
        console.log(sectionIndex)
        var qId = generateUniqueID();
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions: [
                            ...sQItr.section_questions, {
                                id: qId,
                                parent_id: "",
                                survey_section_id: "",
                                input_type_id: generateUniqueID(),
                                input_type_name: "Text",
                                question_name: "",
                                question_subtext: "",
                                question_required_yn: 0,
                                answer_required_yn: 0,
                                option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
                                allow_mutiple_option_answers_yn: 0,
                                dependent_question_id: generateUniqueID(),
                                dependent_question_option_id: generateUniqueID(),
                                dependent_answer_id: generateUniqueID(),
                                question_order: index + 1,
                                question_weight: 0,
                                question_options: [{
                                    id: generateUniqueID(),
                                    question_id: qId,
                                    fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                    fk_option_choice_name: "",
                                    question_option_name: "",
                                    option_order: 0
                                }]
                            }],

                            
                    }
                    : { ...sQItr }
            )
        );
    };

    const handleQuestionAddFromSurvey = (index, sectionIndex, selectedQuestion) => {
        var qId = generateUniqueID();
        var listOfOptions = []
        selectedQuestion.question_options.map((option) => (
            listOfOptions = [...listOfOptions, {
                ...option,
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
            }]
        ))
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions: [
                            ...sQItr.section_questions, {
                                id: qId,
                                parent_id: sQItr.id,
                                survey_section_id: sQItr.id,
                                input_type_id: generateUniqueID(),
                                input_type_name: selectedQuestion.input_type_name,
                                question_name: selectedQuestion.question_name,
                                question_subtext: selectedQuestion.question_subtext,
                                question_required_yn: selectedQuestion.question_required_yn,
                                answer_required_yn: selectedQuestion.answer_required_yn,
                                option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
                                allow_mutiple_option_answers_yn: selectedQuestion.allow_mutiple_option_answers_yn,
                                dependent_question_id: generateUniqueID(),
                                dependent_question_option_id: generateUniqueID(),
                                dependent_answer_id: generateUniqueID(),
                                question_order: index + 1,
                                question_weight: selectedQuestion.question_weight,
                                question_options: [...listOfOptions]
                            }],
                    }
                    : { ...sQItr }
            )
        );
        // console.log(sectionQuestionList)

    }

    // * Finding the section from the index passed and then the question to edit on the particular section
    const handleQuestionChange = (e, index, sectionId, sectionIndex, isAllowMultipleAnswers = 0, isRequired = 0) => {
        let allowMultAns = 0;
        let question_required = 0;

        // If isAllowMutliple answer convert value to 0 or 1 
        if (isAllowMultipleAnswers) {
            if (e === true) //value === 'on'
                allowMultAns = 1
            else
                allowMultAns = 0
        }

        // If isRequired answer convert value to 0 or 1 
        if (isRequired) {
            if (e === true) //value === 'on'
                question_required = 1
            else
                question_required = 0
        }

        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions: sQItr.section_questions.map((section_questions) =>
                            section_questions.question_order === index
                                ? {
                                    ...section_questions,
                                    question_name: !isAllowMultipleAnswers && !isRequired ? e : section_questions.question_name,
                                    parent_id: sectionId,
                                    survey_section_id: sectionId,
                                    allow_mutiple_option_answers_yn: isAllowMultipleAnswers ? allowMultAns : section_questions.allow_mutiple_option_answers_yn,
                                    question_required_yn: isRequired ? question_required : section_questions.question_required_yn
                                }
                                : { ...section_questions }
                        ),
                    }
                    : { ...sQItr }
            )
        );
    };

    const handleQuestionRemove = (index, sectionIndex) => {
        const list = [...sectionQuestionList[sectionIndex].section_questions];
        list.splice(index, 1);
        list.map((itr, index) =>
            itr.question_order = index)
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions:
                            list,
                    }
                    : { ...sQItr }
            )
        )
    };

    // ! ---------------------------------
    // ! SECTION QUESTIONS OPTIONS
    // * Add questions options in the coresponding questions 
    const handleQuestionOptionAdd = (index, sectionIndex, questionIndex, questionId) => {
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions: sQItr.section_questions.map((section_questions) =>
                            section_questions.question_order === questionIndex
                                ? {
                                    ...section_questions,
                                    question_options: [
                                        ...section_questions.question_options, {
                                            id: generateUniqueID(),
                                            question_id: questionId,
                                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                            fk_option_choice_name: "",
                                            question_option_name: "",
                                            //answers_yn:"0",//test for select radio
                                            option_order: index + 1
                                        }
                                    ]
                                }
                                : { ...section_questions }
                        ),
                    }
                    : { ...sQItr }
            )
        );
        // console.log(sectionQuestionList)
    };

    const handleQuestionRatingOptionAdd = (index, sectionIndex, questionIndex, questionId) => {
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions: sQItr.section_questions.map((section_questions) =>
                            section_questions.question_order === questionIndex
                                ? {
                                    ...section_questions,
                                    question_options: [
                                        ...section_questions.question_options, {
                                            id: generateUniqueID(),
                                            question_id: questionId,
                                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                            fk_option_choice_name: "",
                                            question_option_name: "",
                                            option_order: index + 1
                                        },
                                        {
                                            id: generateUniqueID(),
                                            question_id: questionId,
                                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                            fk_option_choice_name: "",
                                            question_option_name: "",
                                            option_order: index + 2
                                        },
                                        {
                                            id: generateUniqueID(),
                                            question_id: questionId,
                                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                            fk_option_choice_name: "",
                                            question_option_name: "",
                                            option_order: index + 3
                                        },
                                        {
                                            id: generateUniqueID(),
                                            question_id: questionId,
                                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                            fk_option_choice_name: "",
                                            question_option_name: "",
                                            option_order: index + 4
                                        },
                                        {
                                            id: generateUniqueID(),
                                            question_id: questionId,
                                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                            fk_option_choice_name: "",
                                            question_option_name: "",
                                            option_order: index + 5
                                        },
                                        {
                                            id: generateUniqueID(),
                                            question_id: questionId,
                                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                                            fk_option_choice_name: "",
                                            question_option_name: "",
                                            option_order: index + 6
                                        }
                                    ]
                                }
                                : { ...section_questions }
                        ),
                    }
                    : { ...sQItr }
            )
        );
        console.log(sectionQuestionList)
    };

    const handleQuestionRatingOptionChange = (e, input_type_name, question_option_id, isResponse = 1, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn = 0, questionId) => {
        // * If response then save on the table
        console.log(e)
        if (isResponse) {
            // * If not allow mutliple answers get all the option ids to disable
            var tempOptions = []
            if (allow_mutiple_option_answers_yn === 0) {
                sectionQuestionList.map((sQItr) => {
                    if (sQItr.section_order === sectionIndex) {
                        sQItr.section_questions.map((section_questions) => {
                            if (section_questions.question_order === questionIndex) {
                                section_questions.question_options.map((qoItr) => {
                                    if (Math.floor(qoItr.option_order / 6) === Math.floor(index / 6))
                                        if (qoItr.id !== question_option_id) {
                                            tempOptions.push(qoItr.id)
                                        }
                                })
                            }
                        })
                    }
                })
            }
            console.log("tempoption:")
            console.log(question_option_id)
            console.log(tempOptions)
            setQuestionOptionResponseList(
                questionOptionResponseList.map((qOItr) =>
                    tempOptions.includes(qOItr.question_option_id) && (input_type_name === "Rating Options")
                        ? {
                            ...qOItr,
                            answer_yn: 0,
                        }
                        : qOItr.question_option_id === question_option_id && (input_type_name === "Rating Options")
                            ? {
                                ...qOItr,
                                answer_yn: 1
                            }
                            : { ...qOItr }
                )
            );
        } else {
            setSectionQuestionList(
                sectionQuestionList.map((sQItr) =>
                    sQItr.section_order === sectionIndex
                        ? {
                            ...sQItr,
                            section_questions: sQItr.section_questions.map((section_questions) =>
                                section_questions.question_order === questionIndex
                                    ? {
                                        ...section_questions,
                                        question_options: section_questions.question_options.map((qoItr) =>
                                            Math.floor(qoItr.option_order / 6) === Math.floor(index / 6)
                                                ? { ...qoItr, question_option_name: e }
                                                : { ...qoItr }
                                        )
                                    }
                                    : { ...section_questions }
                            ),
                        }
                        : { ...sQItr }
                )
            );
        }
        console.log(sectionQuestionList)
        console.log(questionOptionResponseList)
    };

    // * Finding the section from the index passed and then the question to edit on the particular section
    const handleQuestionOptionChange = (val, input_type_name, question_option_id, isResponse = 1, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn = 0, questionId) => {
        console.log(input_type_name)
        console.log(val)
        // * If response then save on the table
        if (isResponse) {
            // * If not allow mutliple answers get all the option ids to disable
            var tempOptions = []
            if (allow_mutiple_option_answers_yn === 0) {
                sectionQuestionList.map((sQItr) => {
                    if (sQItr.section_order === sectionIndex) {
                        sQItr.section_questions.map((section_questions) => {
                            if (section_questions.question_order === questionIndex) {
                                section_questions.question_options.map((qoItr) => {
                                    if (qoItr.id !== question_option_id) {
                                        tempOptions.push(qoItr.id)
                                    }
                                })
                            }
                        })
                    }
                })
            }
            setQuestionOptionResponseList(
                questionOptionResponseList.map((qOItr) =>
                    qOItr.question_option_id === question_option_id && (input_type_name === "True/False Options")
                        ? {
                            ...qOItr,
                            answer_yn: qOItr.answer_yn === 2 || qOItr.answer_yn === 0 ? 1 : 0,
                        }
                        : qOItr.question_option_id === question_option_id && (input_type_name === "Text")
                            ? {
                                ...qOItr,
                                answer_text: val, answer_yn: 0,
                            }
                            : qOItr.question_option_id === question_option_id && (input_type_name === "Slider" || input_type_name === "Rating(10)" || input_type_name === "Rating(5)")
                                ? {
                                    ...qOItr,
                                    answer_numeric: val, answer_yn: 0,

                                }
                                : tempOptions.includes(qOItr.question_option_id) && allow_mutiple_option_answers_yn === 0 && (input_type_name === "Options")
                                    ? {
                                        ...qOItr,
                                        answer_yn: 0,
                                    }
                                    : qOItr.question_option_id === question_option_id && allow_mutiple_option_answers_yn === 0 && (input_type_name === "Options")
                                        ? {
                                            ...qOItr,
                                            answer_yn: 1
                                        }
                                        : qOItr.question_option_id === question_option_id && (input_type_name === "Options") && allow_mutiple_option_answers_yn === 1
                                            ? {
                                                ...qOItr,
                                                answer_yn: qOItr.answer_yn === 2 || qOItr.answer_yn === 0 ? 1 : 0,

                                            }
                                            : { ...qOItr }
                )
            );
        } else {
            setSectionQuestionList(
                sectionQuestionList.map((sQItr) =>
                    sQItr.section_order === sectionIndex
                        ? {
                            ...sQItr,
                            section_questions: sQItr.section_questions.map((section_questions) =>
                                section_questions.question_order === questionIndex
                                    ? {
                                        ...section_questions,
                                        question_options: section_questions.question_options.map((qoItr) =>
                                            qoItr.option_order === index
                                                ? { ...qoItr, question_option_name: val }
                                                : { ...qoItr }
                                        )
                                    }
                                    : { ...section_questions }
                            ),
                        }
                        : { ...sQItr }
                )
            );
        }
        // console.log(question_option_id)
        // console.log(questionOptionResponseList)
    };

    const handleQuestionOptionRemove = (index, sectionIndex, questionIndex) => {
        const list = [...sectionQuestionList[sectionIndex].section_questions[questionIndex].question_options];
        list.splice(index, 1);
        list.map((itr, index) => itr.option_order = index)
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions: sQItr.section_questions.map((SQO) =>
                            SQO.question_order === questionIndex
                                ? {
                                    ...SQO,
                                    question_options: list,
                                }
                                : { ...SQO }
                        )
                    }
                    : { ...sQItr }
            )
        )
        console.log(sectionQuestionList)
    };

    const handleQuestionRatingOptionRemove = (index, sectionIndex, questionIndex) => {
        const list = [...sectionQuestionList[sectionIndex].section_questions[questionIndex].question_options];
        list.splice(index - 5, 6);
        list.map((itr, index) => itr.option_order = index)
        setSectionQuestionList(
            sectionQuestionList.map((sQItr) =>
                sQItr.section_order === sectionIndex
                    ? {
                        ...sQItr,
                        section_questions: sQItr.section_questions.map((SQO) =>
                            SQO.question_order === questionIndex
                                ? {
                                    ...SQO,
                                    question_options: list,
                                }
                                : { ...SQO }
                        )
                    }
                    : { ...sQItr }
            )
        )
        console.log(sectionQuestionList)
    };

    // ! ---------------------------------
    // ! SECTIONS
    // * Changes the state internal variables. The textfields are named the same as the internal variables 
    const handleSectionChange = (e, index) => {
        const list = [...sectionQuestionList];
        // list[index][name] = e;
        list[index].section_name = e
        list[index].section_order = index;
        list[index].survey_header_id = survey.id;
        setSectionQuestionList(list);
    };

    // * Remove Specific Section
    const handleSectionRemove = (index) => {
        const list = [...sectionQuestionList];
        list.splice(index, 1);
        list.map((itr, index) =>
            itr.section_order = index)
        setSectionQuestionList(list);
    };

    // * Add new Section
    const handleSectionAdd = (index) => {
        // console.log(sectionQuestionList)
        var qId = generateUniqueID();
        setSectionQuestionList([...sectionQuestionList, {
            id: generateUniqueID(),
            survey_header_id: "",
            section_name: "",
            section_title: "",
            section_subheading: "",
            section_required_yn: 0,
            section_order: index + 1,
            section_questions: [{
                id: qId, parent_id: "", survey_section_id: "", input_type_id: generateUniqueID(), input_type_name: "", question_name: "",
                question_subtext: "", question_required_yn: 0, answer_required_yn: 0, option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
                allow_mutiple_option_answers_yn: 0, dependent_question_id: generateUniqueID(), dependent_question_option_id: generateUniqueID(),
                dependent_answer_id: generateUniqueID(), question_order: 0, question_weight: 0,
                question_options: [{
                    id: generateUniqueID(),
                    question_id: qId,
                    fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                    fk_option_choice_name: "",
                    question_option_name: "",
                    option_order: 0
                }]
            }]
        }]);
        console.log(sectionQuestionList)
    };

    const handleSectionAddFromSurvey = (index, selected) => {
        // console.log(sectionQuestionList)
        console.log("1")
        var qIdQ = generateUniqueID();
        const IdSection = generateUniqueID();
        var listOfQuestions = []
        var listOfOptions = []
        selected.section_questions.map((question) => (

            qIdQ = generateUniqueID(),
            listOfOptions = [],
            question.question_options.map((option) => (
                listOfOptions = [...listOfOptions, {
                    ...option,
                    id: generateUniqueID(),
                    question_id: qIdQ,
                    fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                    fk_option_choice_name: "",
                }]
            )),

            listOfQuestions = [...listOfQuestions, {
                ...question,
                id: qIdQ,
                parent_id: IdSection,
                survey_section_id: IdSection,
                input_type_id: generateUniqueID(),
                option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
                dependent_question_id: generateUniqueID(),
                dependent_question_option_id: generateUniqueID(),
                dependent_answer_id: generateUniqueID(),
                question_options: [...listOfOptions]
            }]
        ))
        console.log("2")
        console.log("this is the list of questions")
        console.log(listOfQuestions)
        console.log("this is the name of the section")
        console.log(selected.section_name)
        setSectionQuestionList([...sectionQuestionList, {
            id: IdSection,
            survey_header_id: sectionQuestionList[0].survey_header_id,
            section_name: selected.section_name,
            section_title: selected.section_title,
            section_subheading: selected.section_subheading,
            section_required_yn: selected.section_required_yn,
            section_order: index + 1,
            section_questions: [...listOfQuestions]
        }]);
        console.log("sectionQuestionList = ")
        console.log(sectionQuestionList)

    };

    // ! ---------------------------------
    // ! Survey
    // * Change Survey Title
    const handleSurveyTitleChange = (e) => {
        const list = {
            id: survey.id, organization_id: survey.organization_id, survey_name: e, instructions: survey.instructions, other_header_info: "",
            require_login: survey.require_login
        }

        setSurvey(list)
        // console.log(list)
    }

    // * Change Survey Instructions
    const handleSurveyInstructionChange = (e) => {
        const list = {
            id: survey.id, organization_id: survey.organization_id, survey_name: survey.survey_name, instructions: e, other_header_info: "",
            require_login: survey.require_login
        }
        setSurvey(list)
    }

    const toggleRequiredLogedInUser = (e) => {
        const list = {
            id: survey.id, organization_id: survey.organization_id, survey_name: survey.survey_name, instructions: survey.instructions,
            other_header_info: "", require_login: !survey.require_login
        }
        setSurvey(list)
    }

    // ! Refresh Redirect TODO
    // const refresh = useRefresh()
    // const redirect = useRedirect()

    // * Update or Save Survey
    const handleSaveSurvey = async () => {
        console.log("Saving..")
        console.log(survey)
        console.log("ab sur")
        console.log(sectionQuestionList)
        console.log("up sec que li")

        // Check Survey Name if not empty
        if (survey.survey_name === "") {
            showMessage({
                message: 'Please enter survey title',
                type: "error",
                duration: 3000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                ...(Platform.OS === 'web' ? {}  : {floating: true,})
            });
            return;
        }

        var err = false;
        var errMessage = "";
        sectionQuestionList.map((itr) => {
            if (itr.section_name === "") {
                err = true
                errMessage += "Please enter name for Section " + itr.section_order + " \n";
            }

            itr.section_questions.map((innerItr) => {
                if (innerItr.question_name === "") {
                    err = true
                    errMessage += "Please enter name for Question " + innerItr.question_name + " in Section " + itr.section_order + " \n";
                }

            })
        })

        // ! Print error if missing information and exit save
        if (err) {
            console.error(errMessage)
            setErrorCheck(true)
            showMessage({
                message: 'Please complete all the empty fields',
                type: "error",
                duration: 3000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                ...(Platform.OS === 'web' ? {}  : {floating: true,})
            });
            return;
        }

        const surv = []
        surv.push(survey)
        surv.push(sectionQuestionList)

        // TODO Remove.
        console.log("surv=")
        console.log(surv)
        const upd = 0

        // * Post to API
        await postSurvey(clientApi, token, surv, isEdit)
            .then(response => {
                // console.log(surv)
                showMessage({
                    message: 'Survey successfully saved!',
                    type: "success",
                    duration: 3000,
                    position: "top",
                    ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                    ...(Platform.OS === 'web' ? {}  : {floating: true,})
                });
                if (!isCreate)
                    setShowMySurveys(1)
                else
                    setShowSurveysAdmin(1)
                setShowEditScreen(0)
                setShowCreateScreen(0)
                setShowResponseScreen(0)

            })
            .catch(error => {
                showMessage({
                    message: 'Survey failed to save',
                    type: "error",
                    duration: 3000,
                    position: "top",
                    ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                    ...(Platform.OS === 'web' ? {}  : {floating: true,})
                });
                return false;
            });

        // if (postSurvey(token, surv, isEdit)) {
        //     console.log("true")
        //     notify(`Survey successfully saved!`, { type: 'success' });
        //     redirect('/surveys');
        //     refresh();
        // }
        // else {
        //     console.log("false")
        //     notify(`Survey failed to save`, { type: 'error' });
        // }

    }
    // * Cancel 
    const handleCancelSurvey = () => {
        console.log("Cancel..")
        if (!isCreate)
            setShowMySurveys(1)
        else
            setShowSurveysAdmin(1)
        setShowEditScreen(0)
        setShowCreateScreen(0)
        setShowResponseScreen(0)
    }

    // * Submit Response
    const handleSubmitSurveyResponse = async () => {
        var err = false;
        var errMessage = "";

        sectionQuestionList.map((itr) => {
            itr.section_questions.map((innerItr) => {
                if (innerItr.question_required_yn === 1) {
                    // ! All fields must be answered, update depending on question option 
                    var qOItr = questionOptionResponseList[innerItr.question_order];
                    if (qOItr.answer_yn === 2 && qOItr.answer_text === "" && qOItr.answer_numeric === 0) {
                        err = true
                        errMessage += "Please enter a response for Required Question " + innerItr.question_name + " in Section " + (itr.section_order + 1);
                    }
                }

            })
        })


        // ! All fields must be answered, update depending on question option 
        // questionOptionResponseList.map((qOItr) => {
        //     if (qOItr.answer_text === "" && qOItr.answer_numeric === 0) {
        //         err = true
        //         errMessage += "Please enter all required responses for the Survey \n";
        //     }
        // })

        if (err) {
            console.error(errMessage)
            setErrorCheck(true)
            showMessage({
                message: 'Please complete all the required fields',
                type: "error",
                duration: 3000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                ...(Platform.OS === 'web' ? {}  : {floating: true,})
            });
            // { survey.require_login === true && redirect('/surveys'); }
            return;
        }


        // * Post responses to API
        postResponses(clientApi, token, questionOptionResponseList, userSurveySectionList).then((res) => {
            if(res){
                showMessage({
                    message: 'Survey Responses successfully saved!',
                    type: "success",
                    duration: 3000,
                    position: "top",
                    ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                    ...(Platform.OS === 'web' ? {}  : {floating: true,})
                });
                (survey.require_login === true && !isCreate) || isResponse ? setShowMySurveys(1) : setShowSurveysAdmin(1)
                setShowEditScreen(0)
                setShowCreateScreen(0)
                setShowResponseScreen(0)
                //TODO Add redirect */ }
            } else {
                showMessage({
                    message: 'Survey Responses failed to saved!',
                    type: "error",
                    duration: 3000,
                    position: "top",
                    ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                    ...(Platform.OS === 'web' ? {}  : {floating: true,})
                });
            }
        }).catch(() => {
            showMessage({
                message: 'Survey Responses failed to saved!',
                type: "error",
                duration: 3000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                ...(Platform.OS === 'web' ? {}  : {floating: true,})
            });
        })

        if (survey.require_login) {
            if (!isCreate)
                setShowMySurveys(1)
            else
                setShowSurveysAdmin(1)
            setShowEditScreen(0)
            setShowResponseScreen(0)
            setShowResponseScreen(0)
        }
        else {
            setisResult(1);
        }

    }
    //#endregion
    return (
        <KeyboardAwareContainer 
            style={{ flex: 1 }}
            contentContainerStyle={{
                flexGrow: 1,
            }}
            enableOnAndroid
            enableAutomaticScroll
            keyboardShouldPersistTaps="handled"
            extraScrollHeight={Platform.OS !== 'web' ? 100 : 80}
            showsVerticalScrollIndicator={false}
        >
        <SafeAreaView
            style={styles.main}>
            {/* // * Survey Title */}
            <Card style={styles.cardstyle} >
                <Card.Content>
                    <>
                        <CustomInput
                            value={survey.survey_name === "" || survey.survey_name === undefined ? '' : survey.survey_name}
                            editable={isResponse == 1 ? false : true}
                            setValue={handleSurveyTitleChange}
                            type='SURVEYHEADER1'
                            placeholder={survey.survey_name === "" ? 'Survey Title' : survey.survey_name}
                        />
                    </>
                    {isResponse && survey.instructions === "" || survey.instructions === undefined ? <></> :
                        <CustomInput
                            value={survey.instructions === "" || survey.instructions === undefined ? '' : survey.instructions}
                            editable={isResponse == 1 ? false : true}
                            setValue={handleSurveyInstructionChange}
                            type='SURVEYHEADER2'
                            placeholder={survey.instructions === "" ? 'Survey Description' : survey.instructions}
                            multiline={isResponse == 1}
                            scrollEnabled={isResponse == 1}
                        />
                    }
                </Card.Content>
            </Card>

            {/* // * Survey Core */}
            {sectionQuestionList.map((singleSection, index) => (
                <Card style={styles.cardstyle}
                    key={index} >
                    <Card.Content>
                        <CustomSection
                            sectionTitleChange={(e) => handleSectionChange(e, index)}
                            textFieldSectionName="section_name"
                            sectionName={singleSection.section_name}
                            sectionId={singleSection.id}
                            sectionQuestionList={sectionQuestionList[index].section_questions}
                            handleQuestionAdd={handleQuestionAdd}
                            handleQuestionAddFromSurvey={handleQuestionAddFromSurvey}
                            handleQuestionRemove={handleQuestionRemove}
                            handleQuestionChange={handleQuestionChange}
                            sectionIndex={index}
                            handleQuestionTypeChange={handleQuestionTypeChange}
                            handleQuestionRatingOptionRemove={handleQuestionRatingOptionRemove}
                            handleQuestionOptionAdd={handleQuestionOptionAdd}
                            handleQuestionOptionChange={handleQuestionOptionChange}
                            handleQuestionOptionRemove={handleQuestionOptionRemove}
                            questionOptionResponseList={questionOptionResponseList}
                            handleQuestionRatingOptionAdd={handleQuestionRatingOptionAdd}
                            handleQuestionRatingOptionChange={handleQuestionRatingOptionChange}
                            chartOptions={chartOptions}
                            chartData={chartData}
                            noOfUsers={noOfUsers}
                            isResponse={isResponse}
                            isResult={isResultNew}
                            isAnalytics={isAnalytics}
                        />
                        <View style={styles.line} />
                        {!isResponse &&
                            <SafeAreaView className="customButtonRight">
                                {sectionQuestionList.length !== 1 && (
                                    <CustomButton
                                        onPress={() => handleSectionRemove(index)}
                                        iconName='trash-outline'
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='0'
                                        sz={30}
                                    />
                                )}
                            </SafeAreaView>
                        }
                    </Card.Content>
                    <Card.Actions>
                        {sectionQuestionList.length - 1 === index}
                        {/* //* Limit the number of sections, when maximum section number is reached the button disappears   */}
                        {!isResponse && (sectionQuestionList.length - 1 === index && sectionQuestionList.length < 4) && (
                            <PopUp
                                sectionIndex={index}
                                handleAdd={() => handleSectionAdd(index)}
                                setClickListener={handleSectionAddFromSurvey}
                                isSection={1}
                            />
                        )}
                    </Card.Actions>
                </Card>
            ))}
            {/* Require Login and Save Reject Buttons */}
            {(
                !isResultNew &&
                <Card style={styles.cardButtons} >
                    <Card.Actions>
                        <SafeAreaView style={styles.actions} >
                            {!isResponse ?
                                <SafeAreaView
                                    style={styles.modalCheckBoxRow}>
                                    <Checkbox
                                        status={survey.require_login ? 'checked' : 'unchecked'}
                                        onPress={toggleRequiredLogedInUser}
                                    />
                                    <CustomLabel
                                        value={t('common:requireLogedInUser')}
                                        type='RESULTS_SURVEY' />

                                </SafeAreaView> : <></>
                            }

                            {/* Survey Save Buttons */}
                            <SafeAreaView style={styles.modalButtonsRow}>
                                <CustomButton
                                    text={Platform.OS === 'web' && width > 1300 ? t('common:cancel') : ''}
                                    onPress={() => handleCancelSurvey()}
                                    iconName="close-circle-outline"
                                    show='SURVEYREJECT'
                                    type='SURVEYREJECT'
                                    textTop='0'
                                    sz={25}
                                />

                                {isResponse ?
                                    <CustomButton
                                        text={Platform.OS === 'web' && width > 1300 ? t('common:submit') : ''}
                                        onPress={() => handleSubmitSurveyResponse()}
                                        iconName="save-outline"
                                        show='BUTTON_SAVE'
                                        type='SURVEY'
                                        isGradient={true}
                                        textTop='0'
                                        sz={25}
                                    />
                                    :
                                    <CustomButton
                                        text={Platform.OS === 'web' && width > 1300 ? (isEdit ? t('common:updateSurvey') : t('common:saveSurvey')) : ''}
                                        onPress={() => handleSaveSurvey()}
                                        iconName="save-outline"
                                        show='BUTTON_SAVE'
                                        type='SURVEY'
                                        isGradient={true}
                                        textTop='0'
                                        sz={25}
                                    />
                                }
                            </SafeAreaView>
                        </SafeAreaView>
                    </Card.Actions>
                </Card>
            )}
        </SafeAreaView>
    </KeyboardAwareContainer>
    );
}

const makeStyles = (colors, width, height) => StyleSheet.create({
    main: {
        flex: 1,
        alignItems: 'center',
        padding: '10%',
    },
    modalButtonsRow: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: 10,
    },
    modalCheckBoxRow: {
        flex: 1,
        margin: 10,
        marginRight: Platform.OS === 'web' && width > 1300 ? 0 : 40,
        flexDirection: 'row',
    },

    cardstyle: {
        padding: 10,
        margin: 10,
        width: Platform.OS === 'web' && width > 1300 ? width - (width * 20 / 100) : width * 92 / 100,
        borderRadius: 35,
        backgroundColor: colors.background_card,
        elevation: 10,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },

    actions: {
        width: Platform.OS === 'web' && width > 1300 ? width - (width * 20 / 100) : width * 90 / 100,
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    cardButtons: {
        padding: 10,
        margin: 10,
        width: Platform.OS === 'web' && width > 1300 ? width - (width * 20 / 100) : width * 90 / 100,
        borderRadius: 35,
        alignContent: 'flex-end',
        backgroundColor: colors.background_card,
        elevation: 10,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },
    row: {

    },
    line: {
        borderBottomColor: colors.buttons_primary,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: "1%",
        marginBottom: "1%",
    },

});


export default CustomSurvey; 